var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-top-10"},[_c('ExpandAllAccordion',{attrs:{"data":_vm.accordions,"header":"PCR"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }